(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studios-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('studios-lookbook')) {
    customElements.define('studios-lookbook', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('.studios-lookbook__track');
        this.dots = [...this.querySelectorAll('[data-lookbook-index]')];
        this.toggle = this.querySelector('.studios-lookbook__toggle');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches;
        this.visible = false;
        this.interacting = false;
        this.hovered = false;
        this.updateToggle();
        this.track.addEventListener('scroll', () => {
          const index = this.currentIndex();
          this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
          this.schedule();
        }, { ...options, passive: true });
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index), options));
        this.toggle.addEventListener('click', () => {
          this.paused = !this.paused;
          this.updateToggle();
          this.schedule();
        }, options);
        this.track.addEventListener('pointerdown', () => { this.interacting = true; this.schedule(); }, options);
        const release = () => { this.interacting = false; this.schedule(); };
        document.addEventListener('pointerup', release, options);
        document.addEventListener('pointercancel', release, options);
        this.addEventListener('mouseenter', () => { this.hovered = matchMedia('(hover: hover)').matches; this.schedule(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
        this.track.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.goTo(Math.max(0, Math.min(this.dots.length - 1, this.currentIndex() + (event.key === 'ArrowRight' ? 1 : -1))));
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => {
          this.paused = this.motion.matches;
          this.updateToggle();
          this.schedule();
        }, options);
        this.observer = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.schedule();
        }, { threshold: 0.25 });
        this.observer.observe(this);
      }
      currentIndex() {
        return Math.round(this.track.scrollLeft / this.track.clientWidth);
      }
      updateToggle() {
        this.dataset.paused = String(this.paused);
        this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
      }
      goTo(index, wrap = false) {
        this.track.scrollTo({ left: index * this.track.clientWidth, behavior: this.motion.matches || wrap ? 'instant' : 'smooth' });
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.paused || !this.visible || this.hovered || this.interacting || document.hidden) return;
        this.timer = setTimeout(() => {
          const next = (this.currentIndex() + 1) % this.dots.length;
          this.goTo(next, next === 0);
        }, 3000);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studios-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const thumbnail = event.target.closest('[data-studios-photo]');
    if (!thumbnail) return;
    const gallery = thumbnail.closest('.studios-product__gallery');
    const track = gallery.querySelector('.studios-product__slides');
    track.scrollTo({ left: Number(thumbnail.dataset.studiosPhoto) * track.clientWidth });
  });
  document.addEventListener('scroll', (event) => {
    const track = event.target;
    if (!track.matches?.('.studios-product__slides')) return;
    const selected = Math.round(track.scrollLeft / track.clientWidth);
    track.closest('.studios-product__gallery').querySelectorAll('[data-studios-photo]').forEach((button) => {
      button.setAttribute('aria-pressed', String(Number(button.dataset.studiosPhoto) === selected));
    });
  }, { capture: true, passive: true });
  document.addEventListener('change', (event) => {
    const option = event.target.closest('[data-studios-variant]');
    if (!option || !option.checked) return;
    const variantInput = option.form.querySelector('input[name="id"]');
    variantInput.value = option.value;
    variantInput.dispatchEvent(new Event('change', { bubbles: true }));
  });

  } catch(e) { console.error(e); }
})();
})();
